import { dispatch } from '@ori-events/user-action';

/** @deprecated */
export const DATA_ORI_EVENTS_USER_ACTION = '[data-ori-events-user-action]';

/**
 * @deprecated Will be removed.
 * In Online for 3 user-action events "steps_to_success", "Go to the perfect start"; "steps_to_success", "Skip to dashboard"; "steps_to_success", "Save & Share button".
 * Other events using this approach are not consumed by GTM.
 */
export function initUserActionEvents() {
  const links = [...document.querySelectorAll(DATA_ORI_EVENTS_USER_ACTION)];
  links.forEach(link => {
    if (link.dataset.isUserActionInitialized) {
      return;
    }
    link.addEventListener('click', () => {
      const {
        oriEventsUserAction
      } = link.dataset;
      if (!oriEventsUserAction) {
        return;
      }
      const {
        metaHierarchy,
        numberValue
      } = JSON.parse(oriEventsUserAction);
      // Send only "steps_to_success" events for now. This function will get removed later, see its jsdoc.
      if (metaHierarchy?.[0] !== 'steps_to_success') {
        return;
      }
      dispatch(metaHierarchy, numberValue);
    });
    // eslint-disable-next-line no-param-reassign -- x
    link.dataset.isUserActionInitialized = '1';
  });
}